// eslint-disable-next-line jira/restricted/react
import React, { PureComponent } from 'react';
import type { Locale } from '@atlassian/jira-common-constants/src/supported-locales';
import type { Component } from '../../../common/model/types.tsx';
import DeleteSubApp from '../../../delete';
import type {
	OnFail,
	OnDialogDisplay,
	OnIssueCountFetched,
	OnDialogCancel,
} from '../../../delete/model/index.tsx';
import type { AnalyticsData } from '../../../state/analytics/types';

export type Props = {
	component: Component;
	id: string;
	baseUrl: string;
	projectKey: string;
	locale: Locale;
	analyticsData: AnalyticsData;
	relatedIssueUrl: string;
	onDeleteComponentFailure: OnFail;
	onDeleteComponentSuccessful: (component: Component) => void;
	onDeleteDialogDisplay: OnDialogDisplay;
	onDeleteDialogCancel: OnDialogCancel;
	onPatchComponentIssueCount: OnIssueCountFetched;
};

type State = {
	component: Component;
	url: string;
};

// component name is handled via state because we want to show component name when dialog fades out
// eslint-disable-next-line jira/react/no-class-components
class ViewComponent extends PureComponent<Props, State> {
	state: State = {
		component: this.props.component,
		url: this.props.relatedIssueUrl,
	};

	UNSAFE_componentWillReceiveProps(nextProps: Props) {
		const { component, relatedIssueUrl } = nextProps;

		if (component && this.state.component !== component) {
			this.setState({ component });
		}
		if (relatedIssueUrl && this.state.url !== relatedIssueUrl) {
			this.setState({ url: relatedIssueUrl });
		}
	}

	onDeleteComponentSuccessful = () => {
		this.props.onDeleteComponentSuccessful(this.state.component);
	};

	render() {
		const {
			component: { name, issueCount },
			url,
		} = this.state;

		const {
			id,
			locale,
			projectKey,
			analyticsData,
			baseUrl,
			onDeleteComponentFailure,
			onDeleteDialogDisplay,
			onDeleteDialogCancel,
			onPatchComponentIssueCount,
		} = this.props;

		return (
			<DeleteSubApp
				onFail={onDeleteComponentFailure}
				onSuccessful={this.onDeleteComponentSuccessful}
				onDialogDisplay={onDeleteDialogDisplay}
				onIssueCountFetched={onPatchComponentIssueCount}
				onDialogCancel={onDeleteDialogCancel}
				id={id}
				locale={locale}
				analyticsData={analyticsData}
				relatedIssueCount={issueCount}
				relatedIssueUrl={url}
				name={name}
				projectKey={projectKey}
				baseUrl={baseUrl}
			/>
		);
	}
}

export default ViewComponent;
